import {
  sagaList,
  sagaListSuccess,
  sagaOne,
  sagaOneSuccess,
  sagaCreate,
  sagaCreateSuccess,
  sagaUpdate,
  sagaUpdateSuccess,
  sagaDelete,
  sagaSearch,
  sagaSearchSuccess
} from "./ActionTypes";

export const list = (name, params) => {
  return {
    type: sagaList(name),
    data: params
  };
};

export const search = (name, params) => {
  return {
    type: sagaSearch(name),
    data: params
  };
};

export const listSuccess = (name, data) => {
  return {
    type: sagaListSuccess(name),
    data: data
  };
};

export const searchSuccess = (name, data) => {
  return {
    type: sagaSearchSuccess(name),
    data: data
  };
};

export const get = (name, id) => {
  return {
    type: sagaOne(name),
    id: id
  };
};

export const getSuccess = (name, data) => {
  return {
    type: sagaOneSuccess(name),
    data: data
  };
};

export const create = (name, params) => {
  return {
    type: sagaCreate(name),
    data: params
  };
};

export const createSuccess = (name, data) => {
  return {
    type: sagaCreateSuccess(name),
    data: data
  };
};

export const update = (name, params) => {
  return {
    type: sagaUpdate(name),
    data: params,
    id: params.id
  };
};

export const updateSuccess = (name, data) => {
  return {
    type: sagaUpdateSuccess(name),
    data: data
  };
};

export const destroy = (name, payload) => {
  return {
    type: sagaDelete(name),
    id: payload.id,
    data: payload
  };
};

/** Notification Actions **/
import {
  SHOW_NOTIFICATION,
  HIDE_NOTIFICATION,
} from "../constants";

export function showNotification(payload) {
  return { type: SHOW_NOTIFICATION, payload };
}

export function hideNotification() {
  return { type: HIDE_NOTIFICATION };
}

export const showErrorMsg = msg => {
  return {
    type: SHOW_NOTIFICATION,
    payload: {
      type: "error",
      content: msg
    }
  };
};

export const showSuccessMsg = msg => {
  return {
    type: SHOW_NOTIFICATION,
    payload: {
      type: "success",
      content: msg
    }
  };
};

/**Custom admin change password actions**/
export const changeAdminPassword = params => {
  return {
    type: "SAGA_CHANGE_ADMIN_PASSWORD",
    data: params,
    id: params.id
  };
};

export const changePasswordSuccess = (name, data) => {
  return {
    type: "SAGA_CHANGE_ADMIN_PASSWORD_SUCCESS",
    data: data
  };
};



// WEBPACK FOOTER //
// ./src/actions/index.js